import { AddOnSelection, MiniGameAddOnSelection } from '@Config/ticket-form-types'
import { AddOnTypes } from '@Config/types'
import { MiniGameAddOnRuleConfig } from '@interaction-gaming/game-data-service-browser-client'
import { BooleanAddOnCheckbox } from './add-on-checkbox'
import { NumberToggle } from '@Components/number-grid-input/number-grid-input'

type MiniGameAddOnRuleConfigWithHostValue = MiniGameAddOnRuleConfig & {
  iconUrl: string | undefined
}

export type MiniGameAddonCheckboxProps = {
  addonConfig: MiniGameAddOnRuleConfigWithHostValue
  disabled: boolean
  selection?: MiniGameAddOnSelection
  selected: boolean
  onSelect: (addOn: AddOnSelection, selected: boolean) => void
  onEdit: (selection: MiniGameAddOnSelection) => void
}

const CLASS_NAME = 'gby-k2g-ticket-form-mini-game-selections-container'

export const MiniGameAddonCheckbox = ({
  addonConfig,
  disabled,
  selection,
  selected,
  onEdit,
  onSelect,
}: MiniGameAddonCheckboxProps) => {
  return (
    <>
      <BooleanAddOnCheckbox
        key={addonConfig.name}
        disabled={disabled}
        type={AddOnTypes.MINI_GAME}
        selection={addonConfig}
        selected={selected}
        onSelect={(addon, selected) => onSelect(addon, selected)}
      />
      {selection?.numberSelections ? (
        <>
          <div className={CLASS_NAME}>
            {selection?.numberSelections.map((n) => {
              return <NumberToggle key={n} disabled={true} pressed={true} value={n} />
            })}
          </div>
          <button
            className={`${CLASS_NAME}__button`}
            onClick={(e) => {
              e.preventDefault()
              onEdit(selection)
            }}>
            Edit
          </button>
        </>
      ) : null}
    </>
  )
}
